import React, { useState } from "react";
import {
  Envelope,
  EnvelopeFill,
  GeoAlt,
  GeoAltFill,
  Instagram,
  List,
  XLg,
} from "react-bootstrap-icons";
import {
  hamburger,
  header as headerToken,
  button as buttonToken,
  layout,
  button,
  hyperlink,
  heading,
} from "../tokens";
import { Link } from "gatsby";
import { slide as HamburgerMenu } from "react-burger-menu";
import { StaticImage } from "gatsby-plugin-image";
import { contactInfo } from "../contactInfo";
interface HeaderProps {
  children?: any;
  karnet?: boolean;
  hideMenu?: boolean;
  data?: any;
}

export const Header: React.FC<HeaderProps> = () => {
  const header = headerToken();
  const hamburgerToken = hamburger();
  const layoutToken = layout();
  const buttonToken = button();
  const hyperlinkToken = hyperlink();
  const headingToken = heading();

  const [isOpen, setOpen] = useState(false);

  const links = [
    {
      name: "Cennik",
      url: `/cennik`,
    },

    {
      name: "Pakiety Ślubne",
      url: `/pakiety-slubne`,
    },
    {
      name: "Lekcje Makijażu",
      url: `/lekcje-makijazu`,
    },
    {
      name: "Voucher",
      url: `/voucher`,
    },
    {
      name: "Portfolio",
      url: `/portfolio`,
    },
  ];

  const Hamburger = (
    <HamburgerMenu
      className={hamburgerToken.wrapper}
      morphShapeClassName="test"
      itemListClassName={hamburgerToken.list}
      right
      customBurgerIcon={<List />}
      customCrossIcon={<XLg />}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      isOpen={isOpen}
    >
      {links.map((links: any, idx) => (
        <Link
          key={idx + "-hamburger"}
          to={links.url}
          activeClassName={"active"}
          className={hamburgerToken.listItem}
          onClick={() => setOpen(false)}
        >
          <span>{links.name}</span>
        </Link>
      ))}
      <a
        className={hamburgerToken.listItem}
        style={{
          inlineSize: "max-content",
          textDecoration: "none",
        }}
        href={`mailto:${contactInfo.email}`}
      >
        <Envelope style={{ marginInlineEnd: "8px" }} />
        {contactInfo.email}
      </a>
      <a
        className={hamburgerToken.listItem}
        href={contactInfo.instagram}
        style={{ textDecoration: "none" }}
        target="_blank"
      >
        <Instagram style={{ marginInlineEnd: "8px" }} />
        Instagram
      </a>
      <span
        className={hyperlinkToken.base}
        style={{
          textDecoration: "none",
          pointerEvents: "none",
          lineHeight: "1.2",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <span style={{ display: "flex", gap: "4px", alignItems: "center" }}>
          <GeoAltFill /> Poznań
        </span>
      </span>
    </HamburgerMenu>
  );

  return (
    <header className={header.wrapper}>
      <div className={header.content}>
        <div className={header.logoContainer}>
          <Link className={header.logoLink} activeClassName="active" to="/">
            <h1 className={headingToken.logo}>Weronika Filas</h1>
          </Link>
        </div>
        <nav className={header.nav}>
          <ul className={header.navList}>
            {links.map((item, idx) => (
              <li className={header.navListItem} key={idx + "-link"}>
                <Link
                  to={item.url}
                  className={header.navListItemLink}
                  activeClassName="active"
                >
                  {item.name}
                </Link>
              </li>
            ))}
            <li className={buttonToken.header}>
              <a
                href={contactInfo.instagram}
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  alignItems: "center",
                  display: "flex",
                }}
                target="_blank"
              >
                <Instagram
                  style={{ marginInlineEnd: "8px", marginBlockStart: "2px" }}
                />
                <span>Instagram</span>
              </a>
            </li>
          </ul>
        </nav>
        {Hamburger}
      </div>
    </header>
  );
};
